import React from "react";
import {Container} from "react-bootstrap";
import Footer from "./Footer";
import {useLocation} from "react-use";
import {detectSource} from "../utils/sourceDetection";



const Converted = props => {
    const location = useLocation();
  const source = detectSource();
  const isCustomer = source === 'AA' || source === 'AA_MEMBER' || source === 'VTNZ' || source === 'GASPY';
    return (
        <Container>
        <>
            <br />
            <br />

            <p class="text-font-label">This link is no longer live, as the quote is already converted.</p>

          <p class="text-font-label"> If you haven't received the policy document or would like to buy another policy,
            please contact us on <span className='spanLink' onClick={() => {
              isCustomer ? window.location = "tel:0800262411" : window.location = "tel:0800267873"
            }}>{isCustomer ? "0800 262 411" : "0800 267 873"}</span> or <a
              href="mailto:insurance@autosure.co.nz">insurance@autosure.co.nz</a> with your car registration and we'll
            be happy to help.

            </p>

            <p class="text-font-label">Thanks</p>

            <p className="bold-text"><h5 style={{ fontWeight: "bold" }}>The Autosure Team</h5></p>

            <br /><br /><br /><br />

        </>
            <Footer/>
        </Container>
    );
}

export default Converted;
